import CuratenieCentreDeAfaceri from "pages/Servicii/ServiciiSpeciale/CuratenieCentreDeAfaceri";

export default function CuratenieCentreDeAfaceriPage() {
    return <CuratenieCentreDeAfaceri />;
}
